import { Stack, Text, Input, Button, useTheme } from '@ltvco/refresh-lib/theme';
import { AutoAwesomeOutlined } from '@mui/icons-material';
import React from 'react';

import { ErrorMessageWithIcon } from 'components/shared/ErrorMessageWithIcon';

interface IMarketValueFormProps {
  marketValue: string;
  error: string | null;
  onMarketValueChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (e?: React.FormEvent<HTMLFormElement>) => Promise<void>;
}

/**
 * MarketValueForm - Form for entering market value manually
 * @component
 */
export const MarketValueForm = ({
  marketValue,
  error,
  onMarketValueChange,
  onSubmit,
}: IMarketValueFormProps) => {
  const theme = useTheme();

  return (
    <Stack direction="row" width="100%">
      <AutoAwesomeOutlined sx={{ color: theme.palette.primary.main }} />
      <form onSubmit={onSubmit} style={{ width: '100%', marginLeft: '10px' }}>
        <Stack spacing={3} width={{ xs: '100%', md: '360px' }}>
          <Stack spacing={1}>
            <Text variant="body2" sx={{ color: 'text.secondary' }}>
              We couldn&apos;t find the market value for this vehicle. Please
              enter it manually to continue.
            </Text>
            <Input
              fullWidth
              value={marketValue}
              onChange={onMarketValueChange}
              placeholder="Market Value (e.g., 25,000)"
              disabled={false}
              type="text"
            />
          </Stack>
          <ErrorMessageWithIcon errorMessage={error || ''} />
          <Button
            fullWidth
            type="submit"
            variant="contained"
            disabled={!marketValue}
          >
            Continue with Market Value
          </Button>
        </Stack>
      </form>
    </Stack>
  );
};
